module.exports = __webpack_public_path__ + "static/figure-fb1ebe16d8de472c4419489e5048168b.svg";